/**
 * Sign in with email (magic link)
 */
const KAIRO_DOMAIN = "kairo.pm";

export function isKairoEmail(email: string): boolean {
  return email.toLowerCase().endsWith(`@${KAIRO_DOMAIN}`);
}
